import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";

import {
  GET_RENT_DASHBOARD_DATA,
  GetDashboardDataInput,
  GetRentDashboardDataResponse,
} from "~/api/graphql/dashboard";
import FullPageLoader from "~/components/UI/FullPageLoader";
import { RentDashboardData } from "~/types/data/DashboardData.types";

import { RentDashboardGrid } from "./RentDashboardGrid";

interface Props {
  from?: string;
  to?: string;
}

export const RentPage = ({ from, to }: Props) => {
  const [dashboardData, setDashboardData] = useState<RentDashboardData>();
  const [getDashboardDataError, setGetDashboardDataError] =
    useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  const [trigger, { loading }] = useLazyQuery<
    GetRentDashboardDataResponse,
    GetDashboardDataInput
  >(GET_RENT_DASHBOARD_DATA);

  const fetchData = async () => {
    if (loading) return;
    setIsLoading(true);
    const { data, error } = await trigger({
      variables: { GetDashboardDataInput: { from, to } },
    });
    if (data) {
      setDashboardData(data.getRentDashboardData);
    } else if (error) {
      setGetDashboardDataError(error.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [from, to]);

  return !!getDashboardDataError ? (
    <div>Error: {getDashboardDataError}</div>
  ) : isLoading || !dashboardData ? (
    <FullPageLoader />
  ) : (
    <RentDashboardGrid data={dashboardData} to={to} />
  );
};
